// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"382612ac","184":"c3b64770","488":"41eabc53","954":"0caee224"}[chunkId] + ".chunk.js";
};